import type { RxJsonSchema } from 'rxdb';
import type { CategoryDocType } from '../types/category';

export const categorySchema: RxJsonSchema<CategoryDocType> = {
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 36 },
    name: { type: 'string', maxLength: 50 },
    color: { type: 'string', maxLength: 7 },
    icon: { type: 'string', maxLength: 10 },
    sortOrder: { type: 'number', default: 0 },
    parentId: { type: 'string', maxLength: 36 },
    createdAt: { type: 'string' },
    updatedAt: { type: 'string' },
    _deleted: { type: 'boolean', default: false },
  },
  required: ['id', 'name', 'createdAt', 'updatedAt'],
  indexes: ['parentId', 'sortOrder'],
};
